import type {
	GiftType,
	Palette,
	Project,
	TransportParseResult,
	WhoFor,
} from "@brickme/project-core/src/index.ts";
import {
	corePictureToTransportPicture,
	isoDateTimeString,
	isoStringToDate,
	transportPictureConfigurationToCore,
} from "@brickme/project-core/src/index.ts";
import { isEqual, uniqWith } from "lodash-es";
import type { CreateProjectInput } from "~/api/types.generated.ts";
import type { SavedDesignProjectFragment } from "~/api/saved-design-project-fragment.generated.ts";

function apiProjectToCore(
	project: SavedDesignProjectFragment,
	currentPalette: Palette,
): TransportParseResult<Project> {
	const currentPictureResult = transportPictureConfigurationToCore(
		// TODO: Work towards better transport transform functions with api schemas
		project.currentPicture as any,
		currentPalette,
	);
	const otherVersionResults = project.otherVersions.map((o) =>
		// TODO: Work towards better transport transform functions with api schemas
		transportPictureConfigurationToCore(o as any, currentPalette),
	);
	const warnings = uniqWith(
		[
			...Array.from(currentPictureResult.warnings),
			...otherVersionResults.flatMap((o) => Array.from(o.warnings)),
		],
		isEqual,
	);
	return {
		warnings: new Set(warnings),
		result: {
			currentPicture: currentPictureResult.result,
			otherVersions: otherVersionResults.map((o) => o.result),
			updatedAt: isoStringToDate(project.updatedAt.toString()).getTime(),
			whoFor: (project.whoFor as WhoFor | null) ?? undefined,
			giftType: (project.giftType as GiftType | null) ?? undefined,
		},
	};
}

function coreProjectToTransportProject(
	project: Omit<Project, "whoFor" | "giftType"> & {
		readonly whoFor: WhoFor;
		readonly giftType: GiftType | undefined;
	},
	currentPictureBuildNumberOfColours: number,
): Omit<CreateProjectInput, "tempSourceImageKey"> {
	return {
		currentPicture: corePictureToTransportPicture(
			project.currentPicture,
			currentPictureBuildNumberOfColours,
		),
		// Not used anywhere and won't have build, so pass 0
		otherVersions: project.otherVersions.map((p) =>
			corePictureToTransportPicture(p, 0),
		),
		updatedAt: isoDateTimeString(project.updatedAt),
		whoFor: project.whoFor,
		giftType: project.giftType,
	};
}

export { apiProjectToCore, coreProjectToTransportProject };
